const appSettings = {
    BASE_API_URL: window["REACT_APP_API_BASE_URL"],
    REACT_APP_ROOT_URL: window["REACT_APP_ROOT_URL"],
    REACT_APP_API_HEADERS: window["REACT_APP_API_HEADERS"],
    SmarTripRegionalCustomerServiceCenterPhone: window["SmarTripRegionalCustomerServiceCenterPhone"]
};

export default appSettings;


// WEBPACK FOOTER //
// ./src/appSettings.ts